import { render, staticRenderFns } from "./complaintgroup.vue?vue&type=template&id=f8f6d966&lang=true&"
import script from "./complaintgroup.vue?vue&type=script&lang=js&"
export * from "./complaintgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports